import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    actionAccept: 'Confirm',
    actionCancel: 'Cancel',
    b2bOldIbanWarning:
      '**Do not revoke this mandate as part of your migration-related IBAN change**\n\n' +
      'Revoking this mandate may result in future direct debits being rejected if the organisation is slow to take into account your IBAN change.',
    bankAccount: 'On your wallet',
    bankAccountClosed: '{bankAccountName} (closed wallet)',
    coreOldIbanWarning:
      '**Do not revoke this mandate when you change your IBAN due to the migration**\n\n' +
      'Revoking this mandate will suspend all future direct debits, including on your new IBAN.',
    creditorIdentifier: 'SEPA Creditor Identifier (SCI)',
    learnMore: 'Learn more',
    mandateDetails: 'Mandate details',
    modalRevoke: {
      description:
        'Make sure that you inform the organisation that makes these debits (e.g. by means of a letter of cancellation) so that it does not make another attempt to debit your account.',
      title: 'Are you sure you want to suspend this direct debit?',
    },
    modalUnrevoke: {
      description: 'You will find it back in the "Direct Debits" section.',
      title: 'Are you sure you want to resume this direct debit?',
    },
    recipient: 'Beneficiary',
    revokedAt: 'Suspension date',
    revokeMandate: 'Suspend the direct debit',
    showMandate: 'Mandate',
    uniqueMandateReference: 'Unique Mandate Reference (UMR)',
    unrevokeMandate: 'Resume the direct debit',
    warnings: [
      'You cannot contest a B2B Direct Debit once it has been processed.',
    ],
    warningTitle: 'Please note that...',
  },
  fr: {
    actionAccept: 'Confirmer',
    actionCancel: 'Annuler',
    b2bOldIbanWarning:
      '**Ne révoquez pas ce mandat dans le cadre de votre changement de RIB lié à la migration**\n\n' +
      'Révoquer ce mandat risque de rejeter des prélèvements à venir si l’organisme qui vous prélève met du temps à prendre en compte votre changement d’IBAN.',
    bankAccount: 'Sur votre compte',
    bankAccountClosed: '{bankAccountName} (compte clôturé)',
    coreOldIbanWarning:
      '**Ne révoquez pas ce mandat dans le cadre de votre changement de RIB lié à la migration**\n\n' +
      'Révoquer ce mandat suspendra l’ensemble des prélèvements à venir, y compris sur votre nouvel IBAN.',
    creditorIdentifier: 'Identifiant Créancier SEPA (ICS)',
    learnMore: 'En savoir plus',
    mandateDetails: 'Détails du mandat',
    modalRevoke: {
      description:
        'Pensez à en informer l’organisme qui effectue ces prélèvements (via une lettre de résiliation par exemple) afin que celui-ci n’effectue pas de nouvelle tentative de prélèvement sur votre compte.',
      title: 'Êtes-vous sûr·e de vouloir suspendre ce prélèvement\xA0?',
    },
    modalUnrevoke: {
      description:
        'Vous retrouverez ce prélèvement dans la section des prélèvements SEPA actifs.',
      title: 'Êtes-vous sûr·e de vouloir réactiver ce prélèvement\xA0?',
    },
    recipient: 'Bénéficiaire',
    revokedAt: 'Date de la suspension',
    revokeMandate: 'Suspendre le prélèvement',
    showMandate: 'Mandat',
    uniqueMandateReference: 'Référence Unique du Mandat (RUM)',
    unrevokeMandate: 'Réactiver le prélèvement',
    warnings: [
      'Vous ne pouvez pas contester un prélèvement SEPA interentreprises une fois qu’il a été effectué.',
    ],
    warningTitle: 'À noter',
  },
});

export default locales;
